export default "__VITE_ASSET__l8EsR0PY__"